import type { UseFetchOptions } from '#app'
import type { ApiResponse } from '~/types/api.type'
import type { Client } from '~/types/client.type'
import type { Project } from '~/types/project.type'
import type { Report } from '~/types/report.type'
import type { Task } from '~/types/task.type'
import type { TaskList } from '~/types/taskList.type'
import defu from 'defu'

export interface ApiGlobalSearchResults {
  projects: Project<'withClient'>[]
  taskLists: TaskList<'withProject'>[]
  tasks: Task<'withTaskList'>[]
  clients: Client[]
  reports: Report[]
}

export interface ApiGlobalSearchParams {
  search: string
  searchLimit?: number
  withCompleted?: boolean
}

export function useApiGlobalSearch(params: MaybeRefOrGetter<ApiGroupingGetListParams>, options: UseFetchOptions<ApiResponse<ApiGlobalSearchResults>> = {}) {
  const notOverridableOptions: UseFetchOptions<ApiResponse<ApiGlobalSearchResults>> = { method: 'GET', query: params }
  return useApiFetch('/global-search', defu(notOverridableOptions, options))
}
